import withComparisonResources from '../resources/withComparisonResources';

import Comparison from './components/Comparison';

const ComparisonContainer = withComparisonResources(Comparison);
export { Comparison, ComparisonContainer };
